export default {
  description: 'Fügen Sie JSON für den Render-Root oder ein einzelnes Render-Element ein, um die Darstellung zu sehen.',
  jsonInputPlaceholder: 'Render-Root- oder Render-Element-JSON hier einfügen',
  validationErrorSummary: 'Vorschau nicht verfügbar',
  errors: {
    emptyInput: 'Die Eingabe ist leer. Fügen Sie JSON ein, um die Vorschau zu starten.',
    unknownJsonError: 'Unbekannter Fehler beim JSON-Parsing.',
    invalidJson: 'Ungültige JSON-Syntax: {details}',
  },
};
